import React from 'react';

import { SVGComponentProps } from './svg.types';

const CommentsOneSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherSVGProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSVGProps}
    >
      <path
        d="M10 10.25H9.25V11V12.5L6.45 10.4L6.25 10.25H6H3C1.75736 10.25 0.75 9.24264 0.75 8V3C0.75 1.75736 1.75736 0.75 3 0.75H11C12.2426 0.75 13.25 1.75736 13.25 3V8C13.25 9.24264 12.2426 10.25 11 10.25H10Z"
        stroke={fill}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default CommentsOneSVG;
